var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
import { Link as MaterialLink } from '@mui/material';
const StyledLink = styled(MaterialLink)(({ theme, type }) => ({
    color: theme.palette.link.primary,
    fontSize: '.75rem',
    fontWeight: 'normal',
}));
const Link = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return _jsx(StyledLink, Object.assign({}, props, { children: children }));
};
Link.propTypes = {
    children: PropTypes.element.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func,
};
export default Link;
//# sourceMappingURL=Link.js.map